const DEFAULT_API_BASE = "https://api.artha.link/api";

/**
 * Server-side calls prefer API_BASE_URL_INTERNAL (runtime-only env) so SSR
 * traffic reaches the backend over the Docker network instead of hairpinning
 * through the public load balancer. Browser bundles always use the public URL.
 * Env is read at call time so tests can override it per case.
 */
export const getApiBaseUrl = (): string | undefined =>
  typeof window === "undefined" && process.env.API_BASE_URL_INTERNAL
    ? process.env.API_BASE_URL_INTERNAL
    : process.env.NEXT_PUBLIC_API_BASE_URL;

export const getApiBaseUrlWithFallback = (): string =>
  getApiBaseUrl() || DEFAULT_API_BASE;
